<template>
  <NavigationBackButton />
    <div class="configure_template">
      <div v-if="isLoading" class="loading-overlay">
        <div class="loader"></div>
      </div>
  
      <div v-else class="card rounded-top rounded-bottom">
        <div class="card-body">
          <docuseal-builder
            v-if="token"
            :key="builderKey"
            :token="token"
            :autosave="true"
            :with-upload-button="false"
            :with-sign-yourself-button="false"
            :with-send-button="false"
            :only-defined-fields="false"
            :sign-yourself-button="false"
            :add-document-button="false"
            :fields="combined_fields"
            :template-id="template_id"
            :roles="roles"
            @fields-update="on_fields_update"
          ></docuseal-builder>
          
        </div>
      </div>
    </div>
  </template>
  <script src="./configure_template.js"></script>
  

